import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import RTEditor from 'react-rte';

const styles = (theme) => ({
    rteRoot: {
        borderColor: grey[400],
        '&:hover': {
            borderColor: 'black',
        },
    },
    rteToolbar: {
        borderBottom: 'none',
    },
    rteEditor: {
        height: '35vh',
        display: 'inline-block',
        borderTop: `1px solid ${grey[400]}`,
        width: '100%',
        fontFamily: 'sans-serif',
    },
    rteLabel: {
        color: theme.palette.text.secondary,
    },
});

class TextBlockDetails extends React.Component {
    state = {
        editorValue: RTEditor.createEmptyValue(),
    };

    componentDidMount() {
        const editorValue = RTEditor.createValueFromString(this.props.markdown, 'markdown');
        this.setState({ editorValue });
    }

    componentDidUpdate(prevProps) {
        if (this.props.markdown !== prevProps.markdown && this.props.name !== prevProps.name) {
            const editorValue = RTEditor.createValueFromString(this.props.markdown, 'markdown');
            this.setState({ editorValue });
        }
    }

    onChange = (editorValue) => {
        this.setState({ editorValue });
        this.props.handleChange({ target: { id: 'text', value: editorValue.toString('markdown') } });
    };

    render() {
        const { editorProps } = this.props;
        const toolbarConfig = {
            display: [
                'BLOCK_TYPE_DROPDOWN',
                'INLINE_STYLE_BUTTONS',
                'BLOCK_TYPE_BUTTONS',
                'LINK_BUTTONS',
                'HISTORY_BUTTONS',
            ],
            INLINE_STYLE_BUTTONS: [
                { label: 'Bold', style: 'BOLD' },
                { label: 'Italic', style: 'ITALIC' },
                { label: 'Strikethrough', style: 'STRIKETHROUGH' },
            ],
            BLOCK_TYPE_DROPDOWN: [
                { label: 'Normal', style: 'unstyled' },
                { label: 'H1', style: 'header-one' },
                { label: 'H2', style: 'header-two' },
                { label: 'H3', style: 'header-three' },
                { label: 'H4', style: 'header-four' },
                { label: 'H5', style: 'header-five' },
                { label: 'H6', style: 'header-six' },
            ],
            BLOCK_TYPE_BUTTONS: [
                { label: 'Unordered List', style: 'unordered-list-item' },
                { label: 'Ordered List', style: 'ordered-list-item' },
                { label: 'Blockquote', style: 'blockquote' },
            ],
        };

        return (
            <div>
                <Typography variant="subtitle1" className={this.props.classes.rteLabel}>
                    {this.props.label}
                </Typography>
                <RTEditor
                    {...editorProps}
                    toolbarConfig={toolbarConfig}
                    value={this.state.editorValue}
                    onChange={this.onChange}
                    placeholder={this.props.placeholder}
                    className={this.props.classes.rteRoot}
                    toolbarClassName={this.props.classes.rteToolbar}
                    editorClassName={this.props.classes.rteEditor}
                    ariaLabel={this.props.label}
                />
            </div>
        );
    }
}

export default withStyles(styles)(TextBlockDetails);
